import { render, staticRenderFns } from "./AccountPaymentList.vue?vue&type=template&id=4af229c4&"
import script from "./AccountPaymentList.vue?vue&type=script&lang=js&"
export * from "./AccountPaymentList.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports